import React, { useState, useEffect } from 'react';
import AdminStockMovementTable from "../../../components/tables/AdminStockMovementTable";
import AdminInventoryTable from "../../../components/tables/AdminInventoryTable";
import {getInventoryByUserId} from "../../../store/action/inventory";
import {getAdminUser} from "../../../store/action/user";
import axios from "axios";
import {API} from "../../../config";

const AdminStock = ({user, token}) => {
    const [ inventory, setInventory ] = useState([]);
    const [ stockMovements, setStockMovements ] = useState([]);
    const [ loading, setloading ] = useState(true);

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const resInv = await getInventoryByUserId(token, user.id);
            if(resInv.success) {
                setStockMovements(resInv.stock_movements);
                setInventory(resInv.inventory)
            } else {
                alert(resInv.error)
            }

        } catch (e) {
            console.log (e);
            alert(e.message)
        }
        setloading(false)
    };

    const onSendInventoryEmail = async () => {
        try {
            const res = await axios.post(`${API}/v1/admin/inventories/users/${user.id}/email`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                },
            });
            if (res.data.success) {
                alert("Berhasil Kirim Stok")
            } else {
                alert(res.error)
            }
        } catch (e) {
            console.log (e);
            alert(e.error)
        }
    };


    if (loading) {
        return <p>Loading...</p>
    }

    return (
        <div className="row p-4">
            <div className="col-6">
                <div className="row">
                    <div className="col-6">
                        <h5>Inventory</h5>
                    </div>
                    <div className="col-6">
                        <button className="btn-block btn-sm btn-primary" onClick={onSendInventoryEmail}>
                            Kirim Email Stock
                        </button>
                    </div>
                </div>
                <AdminInventoryTable
                    data={inventory}
                    loading={loading}
                />
            </div>
            <div className="col-6">
                <h5>Stock Movement</h5>
                <AdminStockMovementTable
                    data={stockMovements}
                    loading={loading}
                />
            </div>
        </div>
    )
};



export default AdminStock;
